import { Controller } from "@hotwired/stimulus"
import { openPrintReview } from "../utils/exportSchoolFilter"

// The Review button on /admin/orders/itemized_orders. Its href is the bare
// review screen; on click it carries over the School and "Oldest N orders"
// chosen in the bar, so the review shows the same set the metric cards export.
// Without JS the plain link still opens the review screen for every school.
export default class extends Controller {
  open(event) {
    openPrintReview(event)
  }
}
